export default class LocationUtils {

    static getZipCookie() {
        if (document.cookie.split(';').some((item) => item.includes('zip_code='))) {
            return document.cookie
                .split('; ')
                .find(row => row.startsWith('zip_code'))
                .split('=')[1];
        }

        return null;
    }

    static writeZipCookie(zip) {
        document.cookie = `zip_code=${zip}; Domain=${location.hostname.replace('www', '')}; Path=/`;
    }

    /**
     * Will find the user's zip code either from the
     * session cookie or from the geolocation api
     * @param onSuccess
     * @param onError
     * @param useCached
     */
    static getZipCode(onSuccess, onError, useCached = false) {
        if(useCached && LocationUtils.getZipCookie()) {
            onSuccess(LocationUtils.getZipCookie());
        } else {
            this.getDeviceLocation(pos => {
                let formdata = new FormData();
                formdata.append("action", "malarkey_ajax_get_zip");
                formdata.append("lat", pos.coords.latitude.toString());
                formdata.append("lng", pos.coords.longitude.toString());

                let requestOptions = {
                    method: 'POST',
                    body: formdata,
                    redirect: 'follow'
                };

                fetch(window.wp_ajax.AJAX_URL, requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if(result.success) {
                            if(onSuccess) {
                                LocationUtils.writeZipCookie(result.data.zip_code);
                                onSuccess(result.data.zip_code);
                            }
                        } else {
                            if(onError) {
                                onError('Unable to reverse geocode');
                            }
                        }
                    })
                    .catch(error => {
                        if(onError) {
                            onError(error);
                        }
                    });
            }, e => {
                if(onError) {
                    onError(e);
                }
            }, Infinity, 5000);
        }
    }

    static getDeviceLocation(onSuccess, onError, maximumAge = 0, timeout = 5000) {
        const options = {
            enableHighAccuracy: false,
            timeout: timeout,
            maximumAge: maximumAge
        };

        navigator.geolocation.getCurrentPosition(
            pos => {
                if(onSuccess) {
                    onSuccess(pos);
                }
            },
            e => {
                if(onError) {
                    onError(e);
                }
            },
            options);
    }
}